import type { InternalPublicWorkspacesJSON } from 'balus-common';
import type { Workspace } from '@workspace/domain/workspace/Workspace';
import { WorkspaceListItem } from './WorkspaceListItem';

type Props = {
  workspaces: Workspace[];
  internalPublicWorkspaces: InternalPublicWorkspacesJSON;
};

export const WorkspaceList: React.FC<Props> = ({ workspaces, internalPublicWorkspaces }: Props) => {
  return (
    <div className="min-h-full list-none">
      {workspaces.map((workspace) => (
        <div key={workspace.key.toString()} className={'py-2'}>
          <WorkspaceListItem
            workspace={workspace}
            internalPublicSetting={internalPublicWorkspaces[workspace.id] ?? null}
          />
        </div>
      ))}
    </div>
  );
};
